import api from '../../services/service_receive'
import service from '../../services/service'
import Swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import Pagination from 'vue-pagination-2'

export default {
  components: {
    Multiselect,
    Pagination
  },
  data () {
    return {
      header: {
        headers: {
          'access-token': this.$store.state.token
        }
      },
      data_post: '',
      data_config: sessionStorage.config,
      data_bill: [],
      search: '',
      home: null,
      date_search: this.dateMonth(new Date()),
      options: [],
      date_start: this.dateMonth(new Date()),
      date_end: moment(new Date()).add(1, 'M').format('YYYY-MM'),
      modal_date: this.dateFormatDMY2(new Date()),
      modal_total: 0,
      modal_home_area: 0,
      modal_price: 0,
      modal_payment: 0,
      modal_discount: 0,
      modal_description: '',
      activePage: 1,
      allItem: 0,
      ItemPerpage: 10,
      payment_status: 1,
      remark: ''
    }
  },
  methods: {
    callback: function (page) {
      this.activePage = page
      this.searchReceive()
    },
    getHome () {
      this.options = []
      this.$store.state.isLoading = true
      service.getHomeAll(
        result => {
          if (result.response === true) {
            result.data.forEach(val => {
              this.options.push({
                home_id: val['home_id'],
                home_number: val['home_number'],
                home_fullname: val['fullname'],
                home_area: val['home_area']
              })
            })
          } else {
            Swal.fire('ดึงข้อมูลบ้าน', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.data_bill = []
          this.$store.state.isLoading = false
        }
      )
    },
    nameWithLang ({ home_number, home_fullname }) {
      // eslint-disable-next-line camelcase
      return `${home_number} ${home_fullname}`
    },
    searchReceive () {
      this.$store.state.isLoading = true
      var obj = {
        'search': this.search,
        'zone': '',
        'date': this.date_search,
        'active_page': this.activePage,
        'per_page': this.ItemPerpage
      }
      api.getSearchReceive(
        obj,
        this.header,
        result => {
          if (result.response === true) {
            this.data_bill = result.data.pagination
            this.allItem = result.data.count
          } else {
            this.data_bill = []
            Swal.fire('ดึงข้อมูลใบแจ้งหนี้', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.data_bill = []
          this.$store.state.isLoading = false
        }
      )
    },
    getDetail (id) {
      this.$store.state.isLoading = true
      api.getReceiveDetail(
        id,
        this.header,
        result => {
          if (result.response === true) {
            this.data_post = JSON.stringify(result.data)
            setTimeout(
              () => {
                this.$refs.printbill.submit()
                this.$store.state.isLoading = false
              }, 1000
            )
          } else {
            this.data_bill = []
            Swal.fire('ดึงข้อมูลใบแจ้งหนี้', result.message, 'warning')
            this.$store.state.isLoading = false
          }
        },
        error => {
          alert(JSON.stringify(error))
          this.data_bill = []
          this.$store.state.isLoading = false
        }
      )
    },
    printBill () {
      window.print()
    },
    calDiscount () {
      this.modal_payment = this.modal_total - this.modal_discount
    },
    checkAmount () {
      this.modal_discount = this.modal_total - this.modal_payment
    },
    calReceive () {
      if (this.date_start <= this.date_end) {
        setTimeout(() => {
          if (this.home) {
            var obj = {
              home_id: this.home.home_id,
              start_date: moment(this.date_start)
                .startOf('month')
                .format('YYYY-MM-DD'),
              end_date: moment(this.date_end)
                .endOf('month')
                .format('YYYY-MM-DD')
            }
            api.calCentralhome(
              obj,
              this.header,
              result => {
                if (result.response === true) {
                  this.modal_total = result.data.sum_price
                  this.modal_home_area = result.data.home_area
                  this.modal_price = result.data.price
                  this.calDiscount()
                } else {
                  Swal.fire('ดึงข้อมูลค่าส่วนกลาง', result.message, 'warning')
                }
              },
              error => {
                alert(JSON.stringify(error))
              }
            )
          } else {
            if (!this.home) {
              Swal.fire('แจ้งเตือน', 'กรุณาเลือกบ้านเลขที่', 'warning')
            }
          }
          this.$store.state.isLoading = false
        }, 1000)
      } else {
        this.date_start = this.dateMonth(new Date())
        this.date_end = moment(new Date()).add(1, 'M').format('YYYY-MM')
        Swal.fire('แจ้งเตือน', 'กรุณาเลือกเดือนให้ถูกต้อง', 'warning')
      }
    },
    genReceive () {
      $('#Advancepayment').modal('hide')
      if (parseFloat(this.modal_discount) < 0) {
        this.modal_discount = 0
      }
      var obj = {
        home_id: this.home.home_id,
        receive_date: this.modal_date,
        start_date: moment(this.date_start)
          .startOf('month')
          .format('YYYY-MM-DD'),
        end_date: moment(this.date_end)
          .endOf('month')
          .format('YYYY-MM-DD'),
        discount: this.modal_discount,
        invoice_payment: this.modal_payment,
        payment_status: this.payment_status,
        file_bill: '',
        remark: this.remark
      }
      this.$store.state.isLoading = true
      api.genAdvanReceive(
        obj,
        this.header,
        result => {
          if (result.response === true) {
            this.getDetail(result.receive_no)
            this.searchReceive()
            this.home = null
            this.date_start = this.dateMonth(new Date())
            this.date_end = moment(new Date()).add(1, 'M').format('YYYY-MM')
            this.modal_date = this.dateFormatDMY2(new Date())
            this.modal_total = 0
            this.modal_payment = 0
            this.modal_discount = 0
            this.modal_description = ''
            this.remark = ''
          } else {
            $('#Advancepayment').modal('show')
            Swal.fire('ดึงข้อมูลค่าส่วนกลาง', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          $('#Advancepayment').modal('show')
          this.$store.state.isLoading = false
        }
      )
    },
    genReceiveFirstpay () {
      $('#Firstpayment').modal('hide')
      if (parseFloat(this.modal_discount) < 0) {
        this.modal_discount = 0
      }
      var obj = {
        home_id: this.home.home_id,
        receive_date: this.modal_date,
        discount: this.modal_discount,
        invoice_payment: this.modal_payment,
        payment_status: this.payment_status,
        file_bill: '',
        remark: this.remark
      }
      this.$store.state.isLoading = true
      api.genFirstPayReceive(
        obj,
        this.header,
        result => {
          if (result.response === true) {
            this.getDetail(result.receive_no)
            this.searchReceive()
            this.home = null
            this.date_start = this.dateMonth(new Date())
            this.date_end = moment(new Date()).add(1, 'M').format('YYYY-MM')
            this.modal_date = this.dateFormatDMY2(new Date())
            this.modal_total = 0
            this.modal_payment = 0
            this.modal_discount = 0
            this.modal_description = ''
            this.remark = ''
          } else {
            $('#Firstpayment').modal('show')
            Swal.fire('ดึงข้อมูลค่าส่วนกลาง', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          $('#Advancepayment').modal('show')
          this.$store.state.isLoading = false
        }
      )
    },
    genReceiveOther () {
      $('#Otherpayment').modal('hide')
      var home_id = ''
      if (this.home) {
        home_id = this.home.home_id
      }
      if (parseFloat(this.modal_discount) < 0) {
        this.modal_discount = 0
      }
      var obj = {
        home_id: home_id,
        receive_date: this.modal_date,
        discount: this.modal_discount,
        invoice_payment: this.modal_payment,
        payment_status: this.payment_status,
        description: this.modal_description,
        file_bill: '',
        remark: this.remark
      }
      this.$store.state.isLoading = true
      api.genOtherReceive(
        obj,
        this.header,
        result => {
          if (result.response === true) {
            this.getDetail(result.receive_no)
            this.searchReceive()
            this.home = null
            this.date_start = this.dateMonth(new Date())
            this.date_end = moment(new Date()).add(1, 'M').format('YYYY-MM')
            this.modal_date = this.dateFormatDMY2(new Date())
            this.modal_total = 0
            this.modal_payment = 0
            this.modal_discount = 0
            this.modal_description = ''
            this.remark = ''
          } else {
            $('#Advancepayment').modal('show')
            Swal.fire('ดึงข้อมูลค่าส่วนกลาง', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          $('#Advancepayment').modal('show')
          this.$store.state.isLoading = false
        }
      )
    },
    removeReceive (id, amount) {
      Swal.fire({
        title: 'ลบใบเสร็จรับเงิน?',
        text: 'ท่านต้องการลบใบเสร็จรับเงินนี้ใช่หรือไม่ ?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ลบ',
        cancelButtonText: 'ยกเลิก',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.$store.state.isLoading = true
          var obj = {
            'receive_id': id,
            'payment_amount': amount
          }

          api.disabledReceive(
            obj,
            this.header,
            result => {
              if (result.response === true) {
                this.searchReceive()
              } else {
                Swal.fire('ดึงข้อมูลค่าส่วนกลาง', result.message, 'warning')
              }
              this.$store.state.isLoading = false
            },
            error => {
              alert(JSON.stringify(error))
              $('#Advancepayment').modal('show')
              this.$store.state.isLoading = false
            }
          )
        }
      })
    }
  },
  mounted () {
    if (sessionStorage.config) {
      this.$store.state.config = JSON.parse(sessionStorage.config)
      if (this.$route.params.id) {
        this.getDetail(this.$route.params.id)
        this.searchReceive()
      }
      this.getHome()
      this.searchReceive()
    }

    $('input').on('change', function () {
      this.setAttribute(
        'data-date',
        moment(this.value, 'YYYY-MM-DD')
          .format(this.getAttribute('data-date-format'))
      )
    }).trigger('change')
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/receipt.js